<template>
  <div class="article__slider | slider-reset -has-arrows">
    <div class="slider slider-items"> 
        <div v-for="(item, index) in items" :key="index" class="slide-item">
            <figure>
            <img :src="item.image" :alt="item.caption" class="w-full" />
            </figure>
            <figcaption v-if="item.caption">
            {{ item.caption }}
            </figcaption>
        </div>
    </div>
  </div>
</template>
<script>
import { tns } from "tiny-slider/src/tiny-slider";
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  mounted() {
    var slider = tns({
      container: this.$el.querySelector(".slider-items"),
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: false,
      controlsText:  ".."
    });
  }
};
</script>
